export default __webpack_public_path__ + "static/media/Audio-Number-1.eb48ce5a.mp3";